var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 45.3333C84 66.0338 56.263 76 35 76C13.737 76 7 66.0338 7 45.3333C7 24.6329 33.862 7 55.125 7C76.388 7 84 24.6329 84 45.3333Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.259 25.9191C50.8243 23.4096 53.8032 21.857 56.7535 22.0104C59.7038 22.1639 62.504 24.0204 63.8004 26.6789C65.4348 30.0324 64.4493 34.4691 61.5245 36.78C58.5997 39.0909 54.0285 39.0007 51.2239 36.5453C50.3586 35.7871 49.6616 34.8468 49.1223 33.8297C47.8334 31.4015 47.5209 28.2089 49.1929 26.0289",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.436 37.0941C44.3604 35.3684 42.3114 34.3003 40.2834 34.4056C38.2554 34.5109 36.3281 35.7882 35.4373 37.6162C34.3136 39.9225 34.9911 42.9722 37.0026 44.5624C39.0141 46.1511 42.1567 46.0895 44.0855 44.4029C44.6804 43.8824 45.1596 43.2354 45.5307 42.5359C46.417 40.8659 46.6318 38.6708 45.4811 37.1708",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6382 37.1562C49.4494 43.4059 47.2622 49.6571 45.0735 55.9067C44.9443 56.2753 44.8136 56.6605 44.8572 57.0487C44.9383 57.7708 45.5843 58.2808 46.2002 58.6675C52.1669 62.4137 60.3885 62.1534 66.1075 58.0371C66.489 57.7633 66.8826 57.4368 66.9893 56.9795C67.0674 56.6439 66.9742 56.2934 66.8826 55.9624C65.1505 49.7639 63.1286 43.6451 60.8257 37.6362",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8233 65.264C51.5904 60.907 51.4898 56.5424 51.5198 52.1794C51.5303 50.5756 51.5919 48.8635 52.5113 47.5486C53.5118 46.1163 55.5022 45.4679 57.1531 46.0381C58.804 46.6083 59.9728 48.346 59.8796 50.0927",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7956 45.2656C44.8937 48.6191 45.0108 49.6077 45.7363 53.062",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3989 45.3125C37.1451 46.3446 33.8971 57.3323 33.4765 58.3087",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0293 52.5374C34.861 51.6024 34.2951 49.6981 32.9832 50.4852C32.2846 50.9044 31.7081 52.0405 30.7276 51.7362C29.7192 51.4233 29.6667 50.1814 29.9819 49.3759C30.4971 48.0593 30.8943 47.2112 29.9758 46.0171C29.7972 45.7849 29.2962 45.6673 29.0144 45.5734C28.5182 45.408 28.1643 45.161 27.8188 44.7661C27.038 43.8737 26.7497 43.0309 26.5739 41.888C26.448 41.0694 26.8174 40.2345 27.0423 39.4476C27.1852 38.9473 27.5969 38.387 27.5969 37.8945",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9866 37.2782C27.3828 37.8136 23.6832 35.1619 21.9088 33.7692C20.8997 32.327 19.468 29.192 21.8149 28.1895C24.1618 27.187 25.6618 29.1828 26.1184 30.3059C26.8628 29.0167 28.904 26.7573 31.1141 28.0333C33.3241 29.3092 32.7446 30.632 32.1649 31.955L32.1649 31.9551C31.0057 34.6009 28.7414 36.6089 27.9866 37.2782Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeRange);
export default __webpack_public_path__ + "static/media/age_range.0c045d7d584ba7160598c461e9159969.svg";
export { ForwardRef as ReactComponent };